import { TextLayer } from '@deck.gl/layers';
import { useOutletContext } from 'react-router-dom';
import { HeatmapLayer } from '@deck.gl/aggregation-layers';

import Question1Form from '@App/pages/Tablet/Question1/Question1Form';
import Map, {
  MapLegend,
} from '@App/components/Map/Map';
import museumData from '@App/components/Map/data/musea-municipalities.json';
import {
  getCount, getFeatureCoordinates, getFeatureName, getFeatureValue,
} from '../question.utils';

const QUESTION_ID = 'question1';
const HEATMAP_COLORS = [
  [35, 54, 93],
  [31, 128, 121],
  [120, 195, 131],
  [245, 211, 103],
  [230, 119, 70],
];

function buildQuestionData(answerCount) {
  return museumData.features
    .map(feature => ({
      coordinates: getFeatureCoordinates(feature),
      count: getCount(answerCount, [
        getFeatureValue(feature),
        getFeatureName(feature),
      ]),
    }))
    .filter(feature => feature.count > 0);
}

function getQuestionLayers({ data, lastAnswer }) {
  const answer = lastAnswer?.questionId === QUESTION_ID ? lastAnswer.answer : null;
  const selectedFeature = museumData.features.find(feature => (
    getFeatureValue(feature) === answer?.value
  ));
  const selectedMuseum = answer?.coordinates
    ? [{
      coordinates: answer.coordinates,
      name: answer.label || getFeatureName(selectedFeature) || answer.value,
    }]
    : [];

  return [new HeatmapLayer({
    id: 'question-1-heatmap',
    data,
    colorRange: HEATMAP_COLORS,
    getPosition: item => item.coordinates,
    getWeight: item => item.count,
    intensity: 1.2,
    opacity: 0.8,
    radiusPixels: 42,
    threshold: 0.03,
  }), new TextLayer({
    id: 'question-1-museum-label',
    data: selectedMuseum,
    getColor: [255, 255, 255, 235],
    getPosition: item => item.coordinates,
    getSize: 14,
    getText: item => item.name,
    getPixelOffset: [0, -14],
    getTextAnchor: 'middle',
    getAlignmentBaseline: 'bottom',
    outlineColor: [20, 31, 46, 255],
    outlineWidth: 3,
    pickable: false,
  })];
}

function Question1(props) {
  const { withInputFields = false, ...visualizationProps } = props;
  const { lastAnswer: contextLastAnswer } = useOutletContext() || {};
  const lastAnswer = props.lastAnswer ?? contextLastAnswer;
  const focusCoordinates = lastAnswer?.answer?.coordinates || null;

  return (
    <Map
      questionId={QUESTION_ID}
      buildData={buildQuestionData}
      getLayers={getQuestionLayers}
      autoRotate={!withInputFields}
      focusCoordinates={focusCoordinates}
      returnToOverview
      legend={(
        <MapLegend
          lang={props.tabletLang}
          labelKey="legend-popular-museums"
          gradient="linear-gradient(90deg, #23365d, #1f8079, #78c383, #f5d367, #e67746)"
          minLabelKey="legend-few"
          maxLabelKey="legend-many"
        />
      )}
      {...visualizationProps}
    >
      {withInputFields && <Question1Form />}
    </Map>
  );
}

export default Question1;
